export class Decision{
  ulgDecision: string;
  uclDecision: string;
  ulbDecision: string;
  unrDecision: string;
  ulgMemberId: number;
  uclMemberId: number;
  ulbMemberId: number;
  unrMemberId: number;
  ulgMemberUuid: string;
  uclMemberUuid: string;
  ulbMemberUuid: string;
  unrMemberUuid: string;
  automaticDecision: string;
}
